export enum COMPONENT_TYPES {
  NavBar = "NavBar",
  OBNudge = "OBNudge",
  ClustersByPillar = "ClustersByPillar",
  ArticlesByPillar = "ArticlesByPillar",
  AyurvedicCare = "AyurvedicCare",
  ArticlesByTag = "ArticlesByTag",
  TopTips = "TopTips",
  FAQ = "FaqListWithTitle",
  ShopByCatSlider = "ShopByCatSlider",
}
